import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "../components/Box/Box";
import { issueAtom } from "./Summary";
import { FormModel } from "../types/FormTypes";
import { formDataAtom } from "../App";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import {mapFormDataToPayload } from "../utils/mapFormDataToPayload"

export default function ThankYou() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const [issue] = useAtom(issueAtom);

    const isValidFormData = formData?.selectedJourney?.journeyKey;

    useEffect(() => {
        if (!isValidFormData) {
            navigate("/", { replace: true }); 
        }
    }, [isValidFormData, navigate]);
    
    if (!isValidFormData) return null;
    
    const payload = mapFormDataToPayload(formData);
    const emailContact = (payload.Email);
    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("../fler-resor");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
            >
                {({ values }) => (
                    <Form>
                        <Box fullwidth>
                            <h2 className="h2" ref={h2Ref} id="thankYouHeading" tabIndex={-1}>
                                Tack för er anmälan!
                            </h2>
                            <div role="group">
                                <p>
                                    Vi har tagit emot er anmälan. Ni får snart en kopia till mejladressen: <span className="sans-bold">{emailContact}</span>
                                </p>
                                <p>Där finns ert referensnummer. Om ni kontaktar oss behöver ni ange referensnumret. Hittar ni inte mejlet? Kolla i skräpposten.</p>
                                <h3 className="">
                                    Köp biljett
                                </h3>
                                <p>
                                    Biljetter köper ni enklast i vår app eller på <a target="_blank" href="https://ostgotatrafiken.se">ostgotatrafiken.se</a>.
                                    Tips! Köp biljetten tillsammans, så får ni 20 procent i tillsammansrabatt.
                                </p>

                                <p>
                                    Är ni en skolklass som ska resa? Då rekommenderar vi att ni reser med kulturbiljetten. Den
                                    köper ni i vår <a target="_blank" href="https://foretag.ostgotatrafiken.se/">företagsportal</a>.
                                </p>
                            </div>
                        </Box>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
